import { db, storage } from "../../firebase/firebase";
import revealData from '../../util/revealData';

export const getProductsRequest = async (majorId) => {
  try {
    let products = [];
    await db.ref(`products/${majorId}`).once('value', async snap => {
      products = await snap.val() ? Object.values(snap.val()) : [];
    });
    return await revealData(products);
  } catch (error) {
    return error;
  }
}

export const deleteProductRequest = async (productId, majorId) => {
  try {
    await db.ref(`products/${majorId}`).child(productId).remove();
  } catch (error) {
    throw error
  }
}

export const addProductRequest = async (majorId, form) => {
  try {
    const newRef = await db.ref(`products/${majorId}/`).push();
    const uploadTask = 
    await storage
          .ref()
          .child(`products/${majorId}/${newRef.key}`)
          .putString(form.image, 'data_url')
    const imageSrc = await uploadTask.ref.getDownloadURL();
    await newRef.set({
      ...form,
      id: newRef.key,
      image: imageSrc,
    });
  } catch (error) {
    console.log(error)
  }
}

export const editProductRequest = async (majorId, {shouldUpdateImage, ...form}) => {
  try {
    let imageSrc = form.image;
    if(shouldUpdateImage) {
      const uploadTask = 
        await storage
              .ref()
              .child(`products/${majorId}/${form.id}`)
              .putString(form.image, 'data_url')
      imageSrc = await uploadTask.ref.getDownloadURL();
  }

    await db.ref(`products/${majorId}/${form.id}`).set({
      ...form,
      image: imageSrc,
    });
  } catch (error) {
    console.log(error)
  }
}
